/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import './../styles/style.scss';

import { $, $$ } from './lib';
import './blocks/fold';
import './equalizer';
import { Notyf } from 'notyf';
import inView from 'in-view';
import { down, up } from 'slide-element';
import scrollDir from 'scrolldir';

// Base notification styles
let notyf = new Notyf({
  duration: 4000,
  dismissible: true,
  icon: false
});

/*------------------------------------------------------------------
Import external
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {
  // Dynamic Imports
  if (document.querySelector('.js-team')) import(`./team`);
  if (document.querySelector('#blog-filters')) import(`./components/blog`);
  if (document.querySelector('.js-default-accordion')) import(`./blocks/accordion`);
  if (document.querySelector('.js-banner')) import(`./components/banner`);
  if (document.querySelector('select')) import(`./components/selectors`);
  if (document.querySelector('.js-carousel')) import(`./blocks/carousel`);

  console.log('app.js loaded');

  scrollDir();

  const header = document.querySelector('.js-header');
  const headerTrigger = document.querySelector('.js-header__trigger');

  const headerWatcher = new IntersectionObserver((entries) => {
    const trigger = entries[0];
    header.classList.toggle('always-show', trigger.isIntersecting);
  });

  headerWatcher.observe(headerTrigger);

  /*------------------------------------------------------------------
  New Block Images
  ------------------------------------------------------------------*/
  let holders = $$('.image-holder');
  $$('.news-image').forEach((image, index) => {
    if (holders[index]) {
      holders[index].append(image);
    }
  });



  /*------------------------------------------------------------------
  Post Load classname removal
  ------------------------------------------------------------------*/

  $$('.js-postload').forEach(element => {
    element.classList.remove('js-postload');
  });


  /*------------------------------------------------------------------
  Animate elements when they come in to view
  ------------------------------------------------------------------*/

  inView('.js-in-view').on('enter', el => { el.classList.add('inView') })

  /*------------------------------------------------------------------
  Subnav
  ------------------------------------------------------------------*/

  let $subnav_toggle = $('.js-toggle-subnav');
  let $subnav_items = $('.js-subnav-items');

  if ($subnav_toggle) {
    $subnav_toggle.addEventListener('click', () => {

      if ($subnav_toggle.classList.contains('active')) {
        $subnav_toggle.classList.remove('active');
        setTimeout(() => up($subnav_items), 111);
      } else {
        down($subnav_items);
        setTimeout(() => $subnav_toggle.classList.add('active'), 111);
      }

    });
  }


  /*------------------------------------------------------------------
  Subscription form
  ------------------------------------------------------------------*/

  let UDF = $('.userform');

  if (UDF) {

    // Find the submit button
    const submitButton = UDF.querySelector('[type="submit"]');

    // When the submit button is clicked
    submitButton.addEventListener('click', (event) => {
      event.preventDefault();

      if (document.getElementById('g-recaptcha-response') && document.getElementById('g-recaptcha-response').value === '') {
        // Show a success message
        notyf.success({ message: 'Please check the captcha before submitting', icon: false });

        return false;
      }

      let valid = 1;

      [...UDF.elements].forEach((input) => {
        // If the input is the submit button, return
        if (input.type === 'submit') return;
        // if the input is not required, return
        if (!input.required) return;

        if (input.willValidate && !input.checkValidity()) {
          valid = 0;
          // input.classList.add('invalid');
          input.parentNode.classList.add('invalid');
        } else {
          // input.classList.remove('invalid');
          input.parentNode.classList.remove('invalid');
        }
      });

      console.log(valid);

      if (!valid) return;

      // if (document.getElementById('g-recaptcha-response') && document.getElementById('g-recaptcha-response').value === '') {

      //   // Show a success message
      //   notyf.success({ message: 'Please check the captcha before submitting', icon: false });

      //   return false;

      // }

      let formData = new FormData(UDF);


      if (document.getElementById('g-recaptcha-response')) {
        formData.append('g-recaptcha-response', document.getElementById('g-recaptcha-response').value);
      }

      fetch(UDF.getAttribute('action'), {
        method: 'POST',
        body: new FormData(UDF),
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        // If the response is not JSON but the same page, you can return it as text
        return response.text();
      })
      .then(data => {
        // Display a success notification
        notyf.success('Your form has been successfully submitted');

        // Reset the form
        UDF.reset();
      })
      .catch(error => {
        // Display an error notification
        notyf.error('There has been a problem, please try again');
      });
    });

    // UDF.addEventListener('submit', (event) => {

    // });

  }


  /*------------------------------------------------------------------
  Subscription form
  ------------------------------------------------------------------*/

  let NewsletterForm = $('#SubscriptionForm_SubscriptionForm');
  if (NewsletterForm) {

    // Find the submit button
    const submitButton = NewsletterForm.querySelector('[type="submit"]');

    // When the submit button is clicked
    submitButton.addEventListener('click', (event) => {
      event.preventDefault();

      console.log('clicked');

      if (document.getElementById('g-recaptcha-response') && document.getElementById('g-recaptcha-response').value === '') {
        // Show a success message
        notyf.success({ message: 'Please check the captcha before submitting', icon: false });

        return false;
      }

      let valid = 1;

      [...NewsletterForm.elements].forEach((input) => {
        // If the input is the submit button, return
        if (input.type === 'submit') return;
        // if the input is not required, return
        if (!input.required) return;

        if (input.willValidate && !input.checkValidity()) {
          valid = 0;
          // input.classList.add('invalid');
          input.parentNode.classList.add('invalid');
        } else {
          // input.classList.remove('invalid');
          input.parentNode.classList.remove('invalid');
        }
      });

      if (!valid) return;

      let formData = new FormData(NewsletterForm);



      if (document.getElementById('g-recaptcha-response')) {
        formData.append('g-recaptcha-response', document.getElementById('g-recaptcha-response').value);
      }


      fetch(NewsletterForm.getAttribute('action'), {
        method: 'POST',
        body: new FormData(NewsletterForm),
      })
      .then((response) => response.json())
      .then((data) => {


        // Show a success message
        notyf.success({ message: data.message, icon: false });

        // Reset the form
        NewsletterForm.reset();

      })
      .catch((data) => {

        // Show a success message
        notyf.success({ message: 'Something went wrong, please try again.', icon: false });
        console.log(data)
      });
    });

    NewsletterForm.addEventListener('submit', (event) => {
      event.preventDefault();
    });


    /*------------------------------------------------------------------
    Blog filter
    ------------------------------------------------------------------*/
    if ($('#blog-filters')) {
      const params = new URLSearchParams(window.location.search),
      sort = params.get('sort') ?? null;

      if (sort == "ASC") {
        $('#asc').classList.add('active');
      } else if (sort == "DESC") {
        $('#desc').classList.add('active');
      }
    }


    /*------------------------------------------------------------------
    Back button
    ------------------------------------------------------------------*/

    if ($('#back-link')) {
      $('#back-link').addEventListener('click', () => {
        history.back();
      });
    }


    /*------------------------------------------------------------------
    Dark mode style changes
    ------------------------------------------------------------------*/

    // if ($('.page--dark')) {
    //   const accordItems = $('.page--dark').querySelectorAll('.accordion__wrap__item');

    //   accordItems.forEach(item => {
    //     item.addEventListener('click', () => {
    //       if (item.classList.contains('active')) {
    //         item.querySelector('.accordion__wrap__item__heading__cross').src = '/_resources/themes/mercury/dist/images/svg/cross-light.svg';
    //       }
    //     });
    //   });


    //   $('.footer__wrap__left').classList.remove('background--grey-dark');
    //   $('.footer__wrap__right').classList.remove('background--green-darker');
    //   $('.footer__wrap__right h4').classList.remove('colour--blue-light');
    //   $('.footer__wrap__left').style.backgroundColor = '#000';
    //   $('.footer__wrap__right').classList.add('background--red-dark');
    // }


    /*------------------------------------------------------------------
    Banner
    ------------------------------------------------------------------*/
    // if ($('.js-banner')) {
    //     //Get Slides and controls
    //     const slidesArray = $$('.banner__wrap__item'),
    //         controls = Array.from($$('.banner__controls__item')),
    //         banner = $('.js-banner');

    //     function shiftSlides(slideSpeed = 400, animationDelay = 0) {
    //         // Loop through slides and set new positions
    //         slidesArray.forEach((slide, index) => {
    //             let position = parseInt(slide.dataset.position);

    //             // Add transition class to top slide
    //             if (position == 1) {
    //                 slide.classList.add('banner__transition--up');
    //             }

    //             // Afer transition remove all classes and set new positions
    //             setTimeout(function () {
    //                 slide.classList.remove('banner__transition--up');
    //                 slide.querySelector('.banner__wrap__item__content__primary').classList.remove('anitmation--slide-in-out');
    //                 slide.querySelector('.banner__wrap__item__content__secondary').classList.remove('anitmation--slide-in-out');

    //                 if (position == 1) {
    //                     slide.dataset.position = slidesArray.length;
    //                 } else {
    //                     slide.dataset.position = position - 1;
    //                 }

    //                 if (slide.dataset.position == 1) {

    //                     // Animation delay prevents text showing before slide is in position when selected with dots.
    //                     if (animationDelay != 0) {
    //                         setTimeout(function () {
    //                             slide.querySelector('.banner__wrap__item__content__primary').classList.add('anitmation--slide-in-out');
    //                             slide.querySelector('.banner__wrap__item__content__secondary').classList.add('anitmation--slide-in-out');

    //                         }, animationDelay);
    //                     } else {
    //                         slide.querySelector('.banner__wrap__item__content__primary').classList.add('anitmation--slide-in-out');
    //                         slide.querySelector('.banner__wrap__item__content__secondary').classList.add('anitmation--slide-in-out');
    //                     }

    //                     controls[index].classList.add('active');
    //                 } else {
    //                     controls[index].classList.remove('active');
    //                 }
    //             }, slideSpeed);
    //         });
    //     }

    //     controls.forEach((control, index) => {
    //         control.addEventListener('click', function () {
    //             // Set all controls to inactive
    //             controls.forEach(control => control.classList.remove('active'));

    //             // Speed up tranitions until we reach the selected slides
    //             clearInterval(shifter);
    //             shifter = setInterval(() => {
    //                 shiftSlides(400, 0);
    //             }, 450);

    //             // On click scroll through slides until you reach the front one.
    //             let selectedSlide = slidesArray[index];
    //             const observer = new MutationObserver((mutationList, observer) => {
    //                 for (const mutation of mutationList) {
    //                     if (mutation.type === "attributes" && mutation.attributeName === "data-position") {

    //                         if (selectedSlide.dataset.position == 1) {
    //                             // When we reach the selected slide, reset the transition speed.
    //                             clearInterval(shifter);
    //                             shifter = setInterval(() => {
    //                                 shiftSlides(400);
    //                             }, 10000);
    //                         }
    //                     }
    //                 }
    //             });

    //             observer.observe(selectedSlide, { attributes: true });

    //             // Set class active on control that is clicked.
    //             control.classList.add('active');
    //         });
    //     });

    //     // Auto shifter
    //     let shifter = setInterval(() => {
    //         shiftSlides();
    //     }, 10000);
    // }
  }


  /*------------------------------------------------------------------
  Reorder News Block images
  ------------------------------------------------------------------*/
  if ($('.news-block') && window.innerWidth < 1400) {
    let newsBlock = $('.news-block');
    let newsBlockItems = newsBlock.querySelectorAll('.news-block__wrap__item');
    let newsBlockImages = newsBlock.querySelectorAll('.news-block__wrap__item--image');

    newsBlockItems.forEach((item, index) => {
      item.style.order = index + 1;
    });

    newsBlockImages.forEach((image, index) => {
      if (index == 0 || index == 1) {
        image.style.order = 1
      } else if (index == 2) {
        image.style.order = 5
      } else {
        image.style.display = "none";
      }
    });
  }

  [...document.querySelectorAll('.js-main-content')].forEach((content) => {
    // Find all the links
    const links = content.querySelectorAll('.js-main-content__link');

    // Loop all the links
    links.forEach((link) => {
      // Find the img
      const img = link.querySelector('img');
      // Split all the words
      const words = link.textContent.split(' ');

      // Empty the html
      link.innerHTML = '';

      // Loop all the words and add them back to the link, wrap the last word in a span and add the img to it
      words.forEach((word, index) => {
        if (index === words.length - 1) {
          link.innerHTML += `<span>${word}</span>`;
          link.querySelector('span').appendChild(img);
        } else {
          link.innerHTML += `${word} `;
        }
      });
    });
  });
});
